import { en } from "@/locales/en/en";
import { jp } from "@/locales/jp/jp";
import { zh } from "@/locales/zh/zh";

export const locales = {
  en: en,
  ja: jp,
  zh: zh
};
